import { render, staticRenderFns } from "./PaymentFinish.vue?vue&type=template&id=cf64f71e&"
import script from "./PaymentFinish.vue?vue&type=script&lang=js&"
export * from "./PaymentFinish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports